module.exports = __webpack_public_path__ + "static/img/whatsapp.3a2a043.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/whatsapp.png
// module id = fHLY
// module chunks = 1